angular.module('natura').provider("pggConfigProvider", [function () {
    /**
     * CONFIG
     */
    var config = {
        kornyezet: null,
        csrfToken: $('meta[name="csrf-token"]').attr("content"),
        srs: "EPSG:23700",
        bingKey: "AsrQtGPLUpCG9dLCaGZE8B6LWsd3DHUUSoFBBy2WXd9w25u0YaziD-PeoEd7E-HA",
        baseUrl: window.location.origin,
        printUrl: null,
        proxyUrl: null,
        geoserverUrl: null,
        osmCacheUrl: null,
        fomiproxyUrl: null,
        wfsUrl: null,
        geoxUrl: null,
        tablak: []
    };

    this.$get = [function () {
        /**
         * GETTERS AND SETTERS
         */
        var _getConfig = function () {
            return config;
        };
        var _getKornyezet = function () {
            return config.kornyezet;
        };
        var _setKornyezet = function (kornyezet) {
            config.kornyezet = kornyezet;
        };
        var _getCsrfToken = function () {
            return config.csrfToken;
        };
        var _setCsrfToken = function (csrfToken) {
            config.csrfToken = csrfToken;
        };
        var _getBaseUrl = function () {
            return config.baseUrl;
        };
        var _setBaseUrl = function (baseUrl) {
            config.baseUrl = baseUrl;
        };
        var _getSrs = function () {
            return config.srs;
        };
        var _setSrs = function (srs) {
            config.srs = srs;
        };
        var _getProxyUrl = function () {
            return config.proxyUrl;
        };
        var _setProxyUrl = function (proxyUrl) {
            config.proxyUrl = proxyUrl;
        };
        var _getGeoserverUrl = function () {
            return config.geoserverUrl;
        };
        var _setGeoserverUrl = function (geoserverUrl) {
            config.geoserverUrl = geoserverUrl;
        };
        var _getOsmCacheUrl = function () {
            return config.osmCacheUrl;
        };
        var _setOsmCacheUrl = function (url) {
            config.osmCacheUrl = url;
        };
        var _getFomiProxyUrl = function () {
            return config.fomiproxyUrl;
        };
        var _setFomiProxyUrl = function (url) {
            config.fomiproxyUrl = url;
        };
        var _getWfsUrl = function () {
            return config.wfsUrl;
        };
        var _setWfsUrl = function (wfsUrl) {
            config.wfsUrl = wfsUrl;
        };
        var _getGeoxUrl = function () {
            return config.geoxUrl;
        };
        var _setGeoxUrl = function (geoxUrl) {
            config.geoxUrl = geoxUrl;
        };
        var _getPrintUrl = function () {
            return config.printUrl;
        };
        var _setPrintUrl = function (printUrl) {
            config.printUrl = printUrl;
        };
        var _getBingKey = function () {
            return config.bingKey;
        };
        var _setBingKey = function (bingKey) {
            config.bingKey = bingKey;
        };
        var _getTablak = function () {
            return config.tablak;
        };
        var _setTablak = function (tablak) {
            config.tablak = tablak;
        };

        // var _get = function() {
        // return config.;
        // };
        // var _set = function() {
        // config. = ;
        // };

        /**
         * FUNCTIONS
         */

        /**
         * RETURNS
         */
        return {
            getConfig: _getConfig,
            getKornyezet: _getKornyezet,
            setKornyezet: _setKornyezet,
            getCsrfToken: _getCsrfToken,
            setCsrfToken: _setCsrfToken,
            getBaseUrl: _getBaseUrl,
            setBaseUrl: _setBaseUrl,
            getSrs: _getSrs,
            setSrs: _setSrs,
            getProxyUrl: _getProxyUrl,
            setProxyUrl: _setProxyUrl,
            getGeoserverUrl: _getGeoserverUrl,
            setGeoserverUrl: _setGeoserverUrl,
            getFomiProxyUrl: _getFomiProxyUrl,
            setFomiProxyUrl: _setFomiProxyUrl,
            getOsmCacheUrl: _getOsmCacheUrl,
            setOsmCacheUrl: _setOsmCacheUrl,
            getWfsUrl: _getWfsUrl,
            setWfsUrl: _setWfsUrl,
            getGeoxUrl: _getGeoxUrl,
            setGeoxUrl: _setGeoxUrl,
            getPrintUrl: _getPrintUrl,
            setPrintUrl: _setPrintUrl,
            getBingKey: _getBingKey,
            setBingKey: _setBingKey,
            getTablak: _getTablak,
            setTablak: _setTablak
        };
    }];
}]);
